export default __webpack_public_path__ + "static/media/hannah.56c93e0d.jpg";